// ServiceCenter API
import queryString from 'query-string'
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type ServiceCenterRequests = {
    domainName: string,
    get: RequestConfigFunction<{ id: number }>,
    getServiceCenterByLocation: RequestConfigFunction<{ locationId: number }>,
    update: RequestConfigFunction<{ serviceCenterId: number }>,
    create: RequestConfigFunction<undefined>,
    archive: RequestConfigFunction<{ id: number }>,
    restore: RequestConfigFunction<{ id: number }>,
    outboundOrders: RequestConfigFunction<{ serviceCenterId: number }>,
    inboundOrders: RequestConfigFunction<{ serviceCenterId: number }>,
    containersDamaged: RequestConfigFunction<{ serviceCenterId: number }>,
    getContainerStatusBreakdown: RequestConfigFunction<{ serviceCenterId: number }>,
    modifications: RequestConfigFunction<{ id: number }>,
}

const serviceCenterRequests: ServiceCenterRequests = {
    domainName: 'ServiceCenter',
    get: ({
        id,
    }) => {
        return {
            url: `servicecenter/${id}`,
            method: 'GET',
        }
    },
    getServiceCenterByLocation: ({
        locationId,
    }) => {
        return {
            url: queryString.stringifyUrl({
                url: 'servicecenter',
                query: {
                    locationId,
                },
            }),
            method: 'GET',
        }
    },
    update: ({
        serviceCenterId,
    }) => {
        return {
            url: `servicecenter/${serviceCenterId}`,
            method: 'PUT',
        }
    },
    create: () => {
        return {
            url: 'servicecenter',
            method: 'POST',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `servicecenter/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `servicecenter/${id}/restore`,
            method: 'PATCH',
        }
    },
    outboundOrders: ({
        serviceCenterId,
    }) => {
        return {
            url: `servicecenter/${serviceCenterId}/order/filter-request/outbound`,
            method: 'POST',
        }
    },
    inboundOrders: ({
        serviceCenterId,
    }) => {
        return {
            url: `servicecenter/${serviceCenterId}/order/filter-request/inbound`,
            method: 'POST',
        }
    },
    containersDamaged: ({
        serviceCenterId,
    }) => {
        return {
            url: `servicecenter/${serviceCenterId}/container/filter-request/damaged`,
            method: 'POST',
        }
    },
    getContainerStatusBreakdown: ({
        serviceCenterId,
    }: { serviceCenterId: number }) => {
        return {
            url: `servicecenter/${serviceCenterId}/containerstatus-breakdown`,
            method: 'GET',
        }
    },
    modifications: ({
        id,
    }) => {
        return {
            url: `servicecenter/${id}/modifications`,
            method: 'GET',
        }
    },
}

export default serviceCenterRequests
